import { IconInfo, IconX } from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { useAdvertiserBrandProducts } from '../../hooks/useAdvertiserBrandProducts'

import styles from './styles.module.css'

/** Banner de produtos já em "Meus produtos" sem marca; a sugestão vem no modal. */
export const UnassignedSuggestionsBanner: React.FC<{
  onOpen: () => void
  onDismiss: () => void
}> = ({ onOpen, onDismiss }) => {
  const { t } = useAPPTranslation()
  // `total` do envelope: a contagem não depende da página lida
  const { data } = useAdvertiserBrandProducts({ unassigned: true, quantity: 1 })

  const count = data?.total ?? 0

  if (!count) return null

  return (
    <output className={styles.suggestionBanner}>
      <span className={styles.suggestionBannerIcon}>
        <IconInfo />
      </span>

      <p className={styles.suggestionBannerText}>
        {t('rm:advertiserProducts.unassignedSuggestions.banner.text', {
          count
        })}{' '}
        {t('rm:advertiserProducts.unassignedSuggestions.banner.description', {
          count
        })}
      </p>

      <button
        type="button"
        className={styles.suggestionBannerAction}
        onClick={onOpen}
      >
        {t('rm:advertiserProducts.unassignedSuggestions.banner.cta')}
      </button>

      <button
        type="button"
        className={styles.bannerDismiss}
        onClick={onDismiss}
        aria-label={t(
          'rm:advertiserProducts.unassignedSuggestions.banner.dismiss'
        )}
      >
        <IconX />
      </button>
    </output>
  )
}
